export default "__VITE_ASSET__C1vvN8a$__"